import { createContext } from 'react';
const TypesContext = createContext({});

export default TypesContext;
